if (!customElements.get("wishlist-header-button")) {
  customElements.define(
    "wishlist-header-button",
    class WishlistHeaderButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button");
        this.bubble = this.querySelector(".wishlist-count-bubble");
        this.empty = true;
        this.count = 0;
      }
      connectedCallback() {
        this.button.addEventListener(
          "click",
          this.handleButtonClick.bind(this),
        );
        this.init();
      }
      disconnectedCallback() {
        this.button.removeEventListener("click", this.handleButtonClick);
      }
      async init() {
        const customerId = this.dataset.customerId || null;
        if (!this.bubble) return; // don't do anything if it's the mobile drawer button

        if (customerId) {
          try {
            const response = await fetch(
              "https://rarewaves-wishlist.etempashopifyapps-server-b.co.uk/endpoints/count_single_customer_all_wishlists_items.php",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  shopifyCustomerId: customerId,
                }),
              },
            );
            const data = await response.json();
            if (data.failed) {
              throw new Error("Something went wrong retrieving your count");
            } else if (Number(data.total_items_count) > 0) {
              this.count = Number(data.total_items_count);
              this.fillWishlist();
            } else {
              this.empty = true;
              this.bubble.classList.add("empty");
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          const localWishlistsRaw = localStorage.getItem("wishlists");
          let localWishlists = [];

          try {
            const parsedWishlists = JSON.parse(localWishlistsRaw ?? "[]");
            localWishlists = Array.isArray(parsedWishlists)
              ? parsedWishlists
              : [];
          } catch (_error) {
            localWishlists = [];
          }

          const localItemCount = localWishlists.reduce((total, wishlist) => {
            const itemCount = Array.isArray(wishlist?.items)
              ? wishlist.items.length
              : 0;
            return total + itemCount;
          }, 0);

          if (localItemCount > 0) {
            this.count = localItemCount;
            this.fillWishlist();
          } else {
            this.count = 0;
            this.empty = true;
            this.bubble.classList.add("empty");
            Array.from(this.bubble.querySelectorAll("span")).map(
              (span) => (span.textContent = "0"),
            );
          }
        }
      }
      get loadingSpinner() {
        return this.querySelector(".loading__spinner");
      }
      fillWishlist() {
        this.empty = this.count === 0;
        if (!this.bubble) return;

        if (this.empty) {
          this.bubble.classList.add("empty");
          Array.from(this.bubble.querySelectorAll("span")).map(
            (span) => (span.textContent = "0"),
          );
        } else {
          this.bubble.classList.remove("empty");
          Array.from(this.bubble.querySelectorAll("span")).map(
            (span) => (span.textContent = this.count),
          );
        }
      }
      async openWishlist() {
        this.button.classList.add("loading");
        window.location.href = `${Shopify.routes.root}pages/wishlist`
        return false;
      }

      increment() {
        this.count += 1;
        this.fillWishlist();
      }

      decrement() {
        this.count -= 1;
        this.fillWishlist();
      }
      handleButtonClick(e) {
        e.preventDefault();
        if (this.button.classList.contains("loading")) {
          return;
        }
        this.openWishlist();
      }
    },
  );
}
